import React from 'react'
import { useNavigate } from 'react-router-dom';

function Header() {
  const router = useNavigate();
  const pageTurn = (e) => {
    up();
    router(e)
  }

  const up = () => {
     window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' 
    });
}

  return (
    <>
      <header class="sticky top-0 z-50 w-full bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-sm border-b border-gray-200 dark:border-gray-700">
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="flex items-center justify-between h-16">
                    <div class="flex items-center gap-4 text-heading-primary dark:text-white">
           
                    <h2 class="text-xl font-bold" onClick={(e) => pageTurn("/")}>abjpharmacy</h2>
                    </div>
                    <nav class="hidden md:flex flex-1 justify-end items-center gap-8">
                    <div class="flex items-center gap-8">
                    <a class="text-sm font-medium hover:text-primary dark:text-gray-300 dark:hover:text-primary" onClick={(e) => pageTurn("/")}>About us</a>
                    <a class="text-sm font-medium hover:text-primary dark:text-gray-300 dark:hover:text-primary" onClick={(e) => pageTurn("/contact")}>Contact</a>
                    </div>
                    <button class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary/20 text-primary text-sm font-bold leading-normal tracking-[0.015em] hover:bg-primary/30">
                    <span class="truncate">For Healthcare Professionals</span>
                    </button>
                    </nav>
                    <div class="md:hidden">
                    <button class="text-text-primary dark:text-white">
                    <span class="material-symbols-outlined">menu</span>
                    </button>
                    </div>
                    </div>
                </div>
        </header>
    </>
  )
}

export default Header
